import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '../../../atoms/Button'
import { Input } from '../../../atoms/Input'

const StyledModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing.large};
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  min-width: 400px;
  max-width: calc(100vw - 32px);

  @media (max-width: 768px) {
    min-width: auto;
    width: calc(100vw - 32px);
    max-width: 400px;
  }
`

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`

const StyledTitle = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing.medium} 0;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
`

const StyledInputGroup = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`

const StyledLabel = styled.label`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
`

const StyledButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.small};
  margin-top: ${({ theme }) => theme.spacing.large};
`

interface LinkModalProps {
  onSubmit: (url: string, text?: string) => void
  onClose: () => void
}

export const LinkModal: React.FC<LinkModalProps> = ({ onSubmit, onClose }) => {
  const [url, setUrl] = useState('')
  const [text, setText] = useState('')

  const handleSubmit = () => {
    if (url) {
      const finalUrl =
        url.startsWith('http://') || url.startsWith('https://')
          ? url
          : `https://${url}`
      onSubmit(finalUrl, text || undefined)
    }
  }

  return (
    <>
      <StyledOverlay onClick={onClose} />
      <StyledModal>
        <StyledTitle>Insert Link</StyledTitle>

        <StyledInputGroup>
          <StyledLabel>URL</StyledLabel>
          <Input
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com"
            autoFocus
          />
        </StyledInputGroup>

        <StyledInputGroup>
          <StyledLabel>Link Text (optional)</StyledLabel>
          <Input
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Link text"
          />
        </StyledInputGroup>

        <StyledButtonGroup>
          <Button variant="secondary" size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={handleSubmit}
            disabled={!url}
          >
            Insert Link
          </Button>
        </StyledButtonGroup>
      </StyledModal>
    </>
  )
}
